import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sticky-top" }
const _hoisted_2 = { class: "p-1 text-bg-dark" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "d-flex flex-wrap align-items-center justify-content-start" }
const _hoisted_5 = { class: "nav me-auto" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: "/img/logo_bg_black.svg",
  class: "logo-bg-black",
  alt: "nicotto"
}, null, -1)

import { computed } from 'vue'
import { useStore } from '@/store'
import HeaderAuth from '@/components/HeaderAuth.vue'
import HeaderGuest from '@/components/HeaderGuest.vue'
import FlashMessage from '@/components/parts/FlashMessage.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderArea',
  setup(__props) {

const store = useStore()
const isLogin = computed(() => store.getters.isLogin)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/",
                class: "nav-link"
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ])
          ]),
          (_unref(isLogin))
            ? (_openBlock(), _createBlock(HeaderAuth, { key: 0 }))
            : (_openBlock(), _createBlock(HeaderGuest, { key: 1 }))
        ])
      ])
    ]),
    _createVNode(FlashMessage)
  ]))
}
}

})